import { Img } from "./styles";
import avatarImg from "../../assets/icons/avatar.svg"

const Component = (props: any) => {
  return <Img
    preload
    {...props}
    onError={(e) => {
      e.currentTarget.src = avatarImg;
    }}
  />;
};

export default Component;
